import React, { Fragment, useState } from 'react';
import moment from 'moment';
import plusIcon from "../../../../assets/images/icons/plusCircle.png";
import editIcon from "../../../../assets/images/icons/edit.png";
import { ThemeProps } from '../../../genericComponents/globalStyles';
import styled from 'styled-components';
import VolunteerModal from './modals/VolunteerModal';

export default function Volunteer(props) {
  const {
    volunteers,
    addNewVolunteer,
    editVolunteer,
    deleteVolunteer,
  } = props;


  /* state modal display */
  const [volunteerState, setVolunteerState] = useState();
  const [isShowvolunteerModal, setIsShowVolunteerModal] = useState(false);

  /* end state modal display */

  function onAddNewVolunteer(volunteer) {
    addNewVolunteer(volunteer);
    hideVolunteerModal();
  };

  function onEditVolunteer(volunteer) {
    editVolunteer(volunteer);
    hideVolunteerModal();
  };

  function onDeleteVolunteer(volunteer) {
    deleteVolunteer(volunteer);
    hideVolunteerModal();
  };

  function hideVolunteerModal() {
    setIsShowVolunteerModal(false);
    setVolunteerState(undefined);
  }

  return (
    <Fragment>
      <VolunteerModal
        isShow={isShowvolunteerModal}
        onHide={hideVolunteerModal}
        addNewVolunteer={onAddNewVolunteer}
        editVolunteer={onEditVolunteer}
        deleteVolunteer={onDeleteVolunteer}
        editValues={volunteerState}
      />       
      <RowLayout>
        <Text fontSize={"2.1"} marginBottom={"32"}>Volunteering</Text>
        <IconButton onClick={() => setIsShowVolunteerModal(true)}>
          <img src={plusIcon} style={{ width: 30, height: 30 }} />
        </IconButton>
      </RowLayout>
      {volunteers?.length === 0 && (<Text fontSize={"1.5"}>There is no experiences available</Text>)}
      {volunteers?.map((item, index) => (
        <ExperienceContainer key={index}>
          <RowLayout>
            <Text fontSize={"1.8"}>{item.organization_name}</Text>
            <IconButton
              onClick={() => {
                setVolunteerState(item);
                setIsShowVolunteerModal(true);
              }}
            >
              <img src={editIcon} style={{ width: 20, height: 18 }} />
            </IconButton>
          </RowLayout>
          <Text fontSize={"1.5"} color={ThemeProps.color.darkGreen}>
            {`${moment(item.start_date, "MM/YYYY").format('YYYY')} - ${moment(item.end_date, "MM/YYYY").format('YYYY')}`}
          </Text>
        </ExperienceContainer>
      ))
      }
    </Fragment >
  )
}

const ExperienceContainer = styled.div`
  padding: 12px 0;
  border-bottom: 1px solid #ddd;
`;
const RowLayout = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
const Text = styled.p`
  color: ${p => p.color || null};
  font-size: ${(p) => p.fontSize}em;
  margin-bottom: ${(p) => p.marginBottom || "8"}px;
`;
const IconButton = styled.button`
  width: 40px;
  height: 40px;
  background: none;
  outline: none;
  border: none;
`;